import { useEffect, useState } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "react-bootstrap";
import Modal from "react-modal";
import {
  saveImageToFirebaseStorage,
  utilUpdateDocument,
} from "../../../util/UtilsFirebase";
import "./Promociones.css";

export default function Promociones() {
  const { register } = useAuthContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [banners, setBanners] = useState(["", "", "", "", ""]);
  const [bannersI, setBannersI] = useState([null, null, null, null, null]);
  const [mostrar, setMostrar] = useState(["", "", "", "", ""]);
  const customModalStyles = {
    content: {
      width: "600px",
      height: "200px",
      margin: "auto",
      border: "none",
      textAlign: "center",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.15)",
    },
  };

  useEffect(() => {
    if (register.banners) {
      setBanners(register.banners);
      setMostrar(register.banners);
    }
  }, [register]);

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      const banner = [...mostrar];
      const bannerI = [...bannersI];
      const selectedImage = e.target.files[0];

      // Read the image file and create a preview URL
      const reader = new FileReader();
      reader.onloadend = () => {
        bannerI[e.target.id] = selectedImage;
        setBannersI(bannerI);
        banner[e.target.id] = reader.result;
        setMostrar(banner);
      };
      reader.readAsDataURL(selectedImage);
    }
  };

  const handleCancelModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleConfirmModal = async () => {
    let banner = [...banners];
    let i = 0;
    if (banners && banners.length > 0) {
      let path = register.type + "/" + register.id;
      await bannersI.forEach((item, index) => {
        if (item != null) {
          saveImageToFirebaseStorage(path, item).then((downloadURL) => {
            i++;
            if (downloadURL) {
              banner[index] = downloadURL;
              setBanners(banner);
              if (i === bannersI.filter((item) => item != null).length) {
                utilUpdateDocument("registro", register.id, {
                  banners: banner,
                });
                setIsModalOpen(false);
              }
            }
          });
        }
      });
    }
  };
  return (
    <div>
      <h2 className="page-title">PROMOCIONES</h2>
      <Row>
        {mostrar &&
          mostrar.map((item, key) => {
            return (
              <Col className="center">
                <label>
                  Banner {key + 1}:{" "}
                  <img
                    id="logo_img"
                    alt="Error al cargar imagen"
                    style={{ borderRadius: 10 }}
                    src={
                      item !== ""
                        ? item
                        : "https://firebasestorage.googleapis.com/v0/b/rap-dis.appspot.com/o/NoDisponible.png?alt=media&token=a7fd0957-58f8-4f23-9351-d3393fcfe29c"
                    }
                    height="165"
                    width="350"
                  />
                  <input
                    id={key}
                    type="file"
                    style={{ display: "none" }}
                    accept="image/png, image/jpeg"
                    multiple={false}
                    onChange={handleImageChange}
                  />
                </label>
              </Col>
            );
          })}
        <Modal
          style={customModalStyles}
          isOpen={isModalOpen}
          onRequestClose={() => setIsModalOpen(false)}
          contentLabel="Confirmación"
        >
          <p>¿Desea actualizar la informacion?</p>
          <button style={{ marginRight: 5 }} onClick={handleConfirmModal}>
            Aceptar
          </button>
          <button onClick={handleCancelModal}>Cancelar</button>
        </Modal>
      </Row>
      <div className="center-form">
        <Button variant="primary" className="button" onClick={handleSubmit}>
          <FontAwesomeIcon icon={faFloppyDisk} /> ACTUALIZAR
        </Button>
      </div>
    </div>
  );
}
